export const TAG_ICON_PROPS = {
  x: "158.5",
  y: "5.5",
  width: "26",
  height: "26",
  viewBox: "0 0 26 26",
};
